import { render, staticRenderFns } from "./PointerEventsViewer.vue?vue&type=template&id=66a2d6ee&scoped=true&"
import script from "./PointerEventsViewer.vue?vue&type=script&lang=ts&"
export * from "./PointerEventsViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PointerEventsViewer.vue?vue&type=style&index=0&id=66a2d6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a2d6ee",
  null
  
)

export default component.exports